import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=056417c2&scoped=true&"
import script from "./connect.vue?vue&type=script&lang=js&"
export * from "./connect.vue?vue&type=script&lang=js&"
import style0 from "./connect.vue?vue&type=style&index=0&id=056417c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056417c2",
  null
  
)

export default component.exports